import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { LockIcon } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-10 px-4 text-center" data-id="element-52">
      <div className="max-w-xl mx-auto" data-id="element-53">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-54">
          <h2 className="text-2xl sm:text-3xl font-black text-swiss-charcoal mb-3" data-id="element-55">
            Ihr nächstes Semester beginnt heute.
          </h2>
          <p className="text-base sm:text-lg text-gray-700 mb-6 leading-relaxed" data-id="element-56">
            Jede Woche ohne dieses System ist eine Woche, die Sie unnötig
            Stunden investieren. Über 500 Schweizer Lehrpersonen haben bereits
            entschieden. Jetzt sind Sie dran.
          </p>

          <CTAButton href="#pricing" className="mb-3" data-id="element-57">
            ✅ JETZT SYSTEM WÄHLEN
          </CTAButton>

          <div className="text-sm font-bold text-gray-600 mb-1.5" data-id="element-58">
            Basis CHF 19.90 · Experten CHF 23.90 · PDF Sofort-Download
          </div>
          <div className="flex justify-center items-center gap-2 text-xs text-gray-500" data-id="element-59">
            <LockIcon className="w-3 h-3" data-id="element-60" /> Sichere Zahlung | 7-Tage-Garantie |
            Sofortiger Zugang
          </div>
        </motion.div>
      </div>
    </section>;
}